import { PrintInfo } from "../types/misa";

export const generatePrintHTML = (data: PrintInfo): string => {
  if (!data) return "";
  const { header, details, skuLocations, inventorries } = data;
  const totalQuantity = details.reduce((sum, d) => sum + (d.Quantity || 0), 0);

  return `<!DOCTYPE html><html><head><meta charset="utf-8" />
  <title>Phiếu xuất kho - ${header.RefNo}</title>
  <style>
    @page { size: A4; margin: 15mm; }
    body { font-family: "Times New Roman", serif; font-size:12px; line-height:1.4; margin:0; padding:10px; color:#000; }
    .header { text-align:center; margin-bottom:20px; }
    .company-info { text-align:left; margin-bottom:10px; }
    .title { font-size:18px; font-weight:bold; margin:15px 0; }
    table { width:100%; border-collapse:collapse; margin:15px 0; }
    th, td { border:1px solid #000; padding:2px 4px; text-align:center; vertical-align:middle; }
    th { background:#f5f5f5; font-weight:bold; }
    .text-left { text-align:left; } .text-right { text-align:right; }
    .total-row { font-weight:bold; }
    
    /* Footer: ngày tháng + chữ ký luôn đi cùng nhau */
    .footer-wrapper { page-break-inside: avoid; page-break-before: avoid; }
    .footer-date { page-break-inside: avoid; margin-bottom: 15px; text-align: right; }
    .footer { margin-top:10px; display:flex; justify-content:space-between; page-break-inside: avoid; }
    .signature-section { text-align:center; width:18%; page-break-inside: avoid; }
    .signature-title { font-weight:bold; margin-bottom:5px; }
    .signature-note { font-style:italic; margin-bottom:80px; }
    
    @media print { body { print-color-adjust: exact; } }
  </style></head><body>
  <div class="company-info"><strong>CÔNG TY CỔ PHẦN LIÊN KẾT NHÀ THUỐC PHARCECO</strong><br/><strong>Địa chỉ: </strong> Thôn Bá Khê, Xã Văn Giang, Tỉnh Hưng Yên<br/><strong>MST: </strong>0901155224</div>
  <div class="header"><div class="title">PHIẾU XUẤT KHO KIÊM VẬN CHUYỂN NỘI BỘ</div>
    <div class="date-info"><em><strong>Ngày ${
      header.RefDate ? new Date(header.RefDate).toLocaleDateString("vi-VN") : ""
    } </strong></em><br/><strong>Số: ${header.RefNo || ""}</strong></div>
  </div>
  <div class="info-row" style="margin-bottom: 5px"><span class="info-label"><strong>Phương tiện vận chuyển:</strong></span></div>
  <div class="info-row" style="margin-bottom: 5px"><span class="info-label"><strong>Diễn giải:</strong></span> ${
    header.JournalMemo || ""
  }</div>
  <div class="info-row" style="margin-bottom: 5px"><span class="info-label"><strong>Kho xuất: </strong></span>${
    header.BranchName || ""
  }</div>
  <div class="info-row" style="margin-bottom: 5px"><span class="info-label"><strong>Kho nhận: </strong></span>${
    header.ToBranchName || ""
  }</div>
  <table><thead><tr>
    <th style="width:40px;">STT</th><th style="width:80px;">Mã SKU</th><th style="width:50px;">Barcode</th><th style="width:320px;">Tên hàng hóa</th><th style="width:120px;">Vị trí</th><th style="width:80px;">Lô</th><th style="width:80px;">HSD</th><th style="width:50px;">ĐVT</th><th style="width:50px;">SL</th><th style="width:60px;">Ghi chú</th>
  </tr></thead><tbody>
  ${details
    .map(
      (item, i) => `<tr>
      <td>${i + 1}</td>
      <td class="text-left">${item.SKUCode || ""}</td>
      <td class="text-left">${
        inventorries?.find((inv) => inv.SKUCode === item.SKUCode)?.Barcode || ""
      }
      </td>
      <td class="text-left">${item.InventoryItemName || ""}</td>
      <td>${skuLocations?.get(item.SKUCode || "") || ""}</td>
      <td>${item.LotNo || ""}</td>
      <td>${
        item.ExpiryDate
          ? new Date(item.ExpiryDate).toLocaleDateString("vi-VN")
          : ""
      }</td>
      <td>${item.UnitName || "Hộp"}</td>
      <td class="text-right">${item.Quantity || ""}</td>
      <td class="text-left"></td>
    </tr>`
    )
    .join("")}
  <tr class="total-row"><td colspan="8" class="text-center"><strong>Tổng</strong></td><td class="text-right"><strong>${totalQuantity}</strong></td><td></td></tr>
  </tbody></table>
  
  <div class="footer-wrapper">
    <div class="footer-date"><em>Ngày .... tháng .... năm ...........</em></div>
    <div class="footer">
      ${[
        "Thủ kho nhập",
        "Người chịu trách nhiệm chuyên môn",
        "Người vận chuyển",
        "Thu kho xuất",
      ]
        .map(
          (title) =>
            `<div class="signature-section"><div class="signature-title">${title}</div><div class="signature-note">(Ký, họ tên)</div></div>`
        )
        .join("")}
    </div>
  </div>
  </body></html>`;
};
